"use strict";
import Account from "../api/account";
import classNames from "classnames";
import { Link } from "react-router";
import { isIndexerMode } from "./index_audit_split_mode";
var ProgressBar = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "document-indexer__progress" }, /* @__PURE__ */ React.createElement("div", { className: "indexer-progress__container" }, /* @__PURE__ */ React.createElement("ul", { className: "indexer-progress__list" }, _.map(this.props.steps, this.showStep))));
  },
  showStep: function(step) {
    var classes = classNames({
      "indexer-progress__item": true,
      "indexer-progress__item__url": step.url,
      "indexer-progress__item--clickable": step.url || this.stepClickable(step),
      "indexer-progress__item__active": this.props.stepNumber === step.number,
      "indexer-progress__item__completed": this.props.stepNumber > step.number
    });
    var click = _.partial(this.onStepClicked, step);
    return /* @__PURE__ */ React.createElement("li", { className: classes, key: step.number, onClick: click }, this.stepElement(step));
  },
  stepElement: function(step) {
    if (this.showLink(step)) {
      return /* @__PURE__ */ React.createElement(Link, { to: step.url }, this.stepContent(step));
    } else {
      return this.stepContent(step);
    }
  },
  stepContent: function(step) {
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "indexer-progress__indicator" }, /* @__PURE__ */ React.createElement("div", { className: "indexer-progress__indicator-inner" }, "\xA0")), /* @__PURE__ */ React.createElement("span", null, " ", step.label), this.possibleTrailer(step));
  },
  showLink: function(step) {
    return step.url && parseInt(this.props.stepNumber) !== step.number;
  },
  possibleTrailer: function(step) {
    if (step.number !== _.last(this.props.steps).number) {
      return /* @__PURE__ */ React.createElement("hr", { className: "indexer-progress__trailer" });
    }
  },
  stepClickable: function(step) {
    return this.props.onStepClicked && step.number <= this.props.stepNumber;
  },
  onStepClicked: function(step) {
    if (this.stepClickable(step)) {
      this.props.onStepClicked(step);
    }
  }
});
var IndexerProgress = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement(
      ProgressBar,
      {
        steps: this.steps(),
        onStepClicked: this.props.onStepClicked,
        stepNumber: this.props.stepNumber
      }
    );
  },
  batchUrl: function() {
    if (this.props.batchId && this.props.stepNumber === 4) {
      let onDone = "/dashboard";
      if (this.props.location && this.props.location.query.onDone) {
        onDone = this.props.location.query.onDone;
      }
      return "/index-document-batches/" + this.props.batchId + "?onDone=" + encodeURIComponent(onDone);
    } else {
      return null;
    }
  },
  inIndexerMode: function() {
    return isIndexerMode(this.props.location);
  },
  steps: function() {
    var steps = [
      { number: 0, label: this.stepLabel(0) },
      { number: 1, label: this.stepLabel(1) },
      { number: 2, label: this.stepLabel(2) },
      {
        number: 3,
        label: this.stepLabel(3),
        url: this.batchUrl()
      },
      { number: 4, label: this.stepLabel(4) }
    ];
    return steps.filter((step) => step.label);
  },
  stepIndex3Label: function() {
    if (Account.hasRole("Factor")) {
      if (this.inIndexerMode()) {
        return "Assign Debtor";
      } else {
        return "Create and Submit Invoice";
      }
    } else {
      if (this.props.multiCarrier) {
        return `Assign Loads & ${Account.carrierTerm()}s`;
      } else {
        return "Assign Loads";
      }
    }
  },
  stepIndex4Label: function() {
    if (Account.hasRole("Factor")) {
      if (this.inIndexerMode()) {
        return "Review";
      } else {
        return null;
      }
    } else {
      if (this.inIndexerMode()) {
        return null;
      } else {
        return "Confirm & Submit";
      }
    }
  },
  stepLabel: function(stepIndex) {
    return [
      function() {
        return `Assign ${Account.carrierTerm()}`;
      },
      function() {
        return "Identify Documents";
      },
      function() {
        return "Group Documents";
      },
      function() {
        return this.stepIndex3Label();
      }.bind(this),
      function() {
        return this.stepIndex4Label();
      }.bind(this)
    ][stepIndex]();
  }
});
var ReplyProgressBar = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement(
      ProgressBar,
      {
        steps: this.steps,
        stepNumber: this.props.stepNumber
      }
    );
  },
  steps: [
    { number: 1, label: "View Reply" },
    { number: 2, label: "Identify Documents" },
    { number: 3, label: "Validate & Accept" }
  ]
});
var NoDocumentsProgressBar = React.createClass({
  render: function() {
    return /* @__PURE__ */ React.createElement(
      ProgressBar,
      {
        steps: this.steps,
        stepNumber: this.props.stepNumber
      }
    );
  },
  steps: [
    { number: 0, label: `Assign ${Account.carrierTerm()}` },
    { number: 1, label: "Respond or Complete" }
  ]
});
export { ProgressBar, IndexerProgress, ReplyProgressBar, NoDocumentsProgressBar };
